import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { createModality } from "../../../../services/modality";
import { useEffect } from "react";
import { genderOptions } from "../../../../interfaces/modality";

interface AdminModalityNewProps {
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminModalityNew(props: AdminModalityNewProps) {

    useEffect(() => {
        
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            name: event.target.name.value,
            description: event.target.description.value,
            gender: event.target.gender.value
        }
        createModality(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    return (
        <Modal className="admin-modality-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("new_modality") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                            <Form.Control type="text" name="name" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="gender">
                            <Form.Label aria-required="true">{ t("gender") }</Form.Label>
                            <Form.Select aria-label={ t("gender") } required>
                                <option value="">{ t("select_gender") }</option>
                                { genderOptions.map((g: any) => {
                                    return <option key={ 'gender-' + g.value } value={ g.value }>{ t(g.label) }</option>
                                })}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="description">
                            <Form.Label>{ t("description") }</Form.Label>
                            <Form.Control name="description" as="textarea" />
                        </Form.Group>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}